export default __webpack_public_path__ + "static/feature_02-a7d103dd0611f2124f0465cf9c90fef8.png";